// extracted by mini-css-extract-plugin
export default {"container":"descriptionBlock_container__MbzJu","header":"descriptionBlock_header__ikeoG","description":"descriptionBlock_description__5C9GN"};